import { Cell } from '@/components/Bicester/Table/Cells/index';
import React from 'react';
import { Button } from '../..';
import _ from 'lodash';
import { usePersistFn } from 'ahooks';

type OperationType = 'DELETE' | 'DETAIL';

enum OPERATION {
  'DELETE' = '删除',
  'DETAIL' = '查看',
}

interface Operations {
  name: string;
  show?: boolean | ((rowData?: any) => boolean);
  onClick?: (rowData?: any) => void;
  readonly?: boolean;
}

export interface OperationCellProps {
  rowData?: BaseObject<any>;
  id?: number | string;
  dataKey?: string;
  operation?: OperationType;
  operations?: Operations[] | ((rowData: any) => Operations[]);
  btnName?: string;
  onClick?: (rowData: BaseObject<any>) => void;
  style?: React.CSSProperties;
}

const OperationCell = ({
  rowData,
  id,
  operation = 'DETAIL',
  operations,
  btnName,
  onClick,
  ...props
}: OperationCellProps) => {
  const opts = _.isFunction(operations) ? operations(rowData) : operations;

  const renderBtns = usePersistFn(
    ({ name, onClick: handle, show = true, readonly, disabled }, index) => {
      if (!show) return;
      if (readonly) return name;
      return (
        <Button
          appearance="link"
          key={name}
          disabled={disabled}
          onClick={() => handle(rowData)}
          style={{ marginRight: index === opts.length - 1 ? 0 : 8 }}
        >
          {name}
        </Button>
      );
    }
  );

  return (
    <Cell {...props}>
      {opts ? (
        opts?.map(renderBtns)
      ) : (
        <Button appearance="link" onClick={() => onClick(rowData)}>
          {btnName || OPERATION[operation]}
        </Button>
      )}
    </Cell>
  );
};

export default OperationCell;
